import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

function InstituteEnrollCourseCard({ courses = [] }) {
  const [showNavigation, setShowNavigation] = useState(false);
  const safeCourses = Array.isArray(courses) ? courses : [];

  // Function to determine if navigation should be shown based on screen width
  const checkNavigationNeeded = () => {
    const screenWidth = window.innerWidth;
    let slidesPerView = 3; // default

    if (screenWidth < 768) {
      slidesPerView = 1;
    } else if (screenWidth < 1150) {
      slidesPerView = 2;
    } else {
      slidesPerView = 3;
    }

    setShowNavigation(safeCourses.length > slidesPerView);
  };

  useEffect(() => {
    if (safeCourses.length > 0) {
      checkNavigationNeeded();
      window.addEventListener("resize", checkNavigationNeeded);

      return () => {
        window.removeEventListener("resize", checkNavigationNeeded);
      };
    }
  }, [safeCourses.length]);

  if (safeCourses.length === 0) {
    return null;
  }

  return (
    <div className="card-body">
      <div className="mb-4">
        <h6 className="text-muted fw-semibold">Courses in this Program</h6>
      </div>
      <div style={{ position: "relative" }}>
        <Swiper
          spaceBetween={24}
          slidesPerView={3}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          navigation={
            showNavigation
              ? {
                  nextEl: ".swiper-button-next-custom",
                  prevEl: ".swiper-button-prev-custom",
                }
              : false
          }
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={true}
          modules={[Pagination, Navigation, Autoplay]}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1150: { slidesPerView: 3 },
          }}
          style={{ paddingBottom: "2rem" }}
        >
          {safeCourses.map((course, idx) => (
            <SwiperSlide key={idx}>
              {/* Updated Link to pass course ID as URL parameter */}
              <Link
                to={`/my-program/${course.id}`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div
                  className="card yellowborder h-100 shadow-sm hover-shadow transition-all"
                  style={{ minHeight: "120px" }}
                >
                  <div className="card-body p-4 fillcolor">
                    <div className="d-flex flex-column h-100">
                      <div className="d-flex-custom mb-3">
                        <div className="flex-shrink-0 me-4">
                          <div className="avatar-sm">
                            <span className="avatar-title bg-warning-subtle rounded-circle p-1">
                              <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAYAAADhu0ooAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEZUlEQVR4nOXZfWgbZRwH8FPYPWFlk7F/FDZBp8jYnxWR0bsM3NjW3mU4KdVN51q7jvZ50qXtujhfqMOXKDJc7HOJhangrGgZ0xX8w72hTBnWl/lS6UTm2FsuiW2TtlvT1D75SdKlJDFts8vlpbkvfP867rn75HnyHJdwnJ7pgDtNFCp4yrp4hfkRZT3IBes5gDu4UsgiCmsQZW/yClOREoHU8pRdiR5H78J93EKLSYGVvAvsiLIL6XDpyxivsG+RCxq4t6GMK9q4YJlJgR08ZScRZZHMgWlKWZBX2EexpV0UcQLiFZCXuad6TZRNZoWbpWVu9ld0dSymcHd+cR3TmwpSmJNX2GAucLPM8lR0tfAuqOZ6gM+ZD1F4AFH2Fq+wq3nDzdLYrq2wd0xdcK/+UIU5Cg28NbOhnD6a0P+g7BNE2adIYeN5wEV4hZ1FFOq4w7BEd9xcUL4TbLEDTlhKTtzoqTwWgjK3vsCVH0yB5dj4Od4ND3L5CpoNynHcdVXd71G9cP6SH14/Owrl3WHNuCVuBlu/GIcjPwfgynUveDxeR96QmUIT+/Wfg2A/MwarPvw3I+DD3eHYh/THZX/SOEUP9dzqNY8XevuHYOeXN2F5F0vCrXh/CnZ/dQNODwymPTcd1LzJuqKiqvF+LRUet92TM2hiL17zgasvGEPPLM35zkuBihL5VZQJaC/+fn11w105hWqpqvoOAcDyeNdtae7PDkpAkLGt6KCjo2OQmFqrIyukOD2rjqKH7jvghid3vXJblbbZFx5US3qOn8kcylNo5ym7GC9SoDZ+zOPxtuUMOpZn6HxRVXXN4NBQr8//T9Y4r88PgWAQJsLhrJG6Q6MBgProwOHwJIyMjMZu+HZxoYkJXXCaocgJq1AnbIg33StSHJqYudCq1wfDgWlcJBLRHagNStlrSZsRhbZMoPFEIVFQIBCE4eFAOBTKLS4nULGycbUoY/v+V9872n30BJz7oX++awcgj9ENapbJU4kDOQ4dWbhQkwJreQVa413kgvKZGZXwtpKBzhWhyro9E6i8/fmkC4ZC4YUFrZDJ04aAilVkhyGggoyfNQiU7DQE1CzhWkNARYu1zhBQQSbPGQMq4XpDQM1VZJchoKKMGwwBFSSy2xBQs9zUaAioKJEmQ0AFCWNjQGVCDAGtkLHVEFBRIs3GgFrwnlRocGQM+gf+hh9/uTDTzTXtSRf8ru/3pOO56kHXZ7q9j9oSB9pY3QbrLNaUwYupWON3VCIthb/5PEBFCbcaAyqTttTBoku3rvkNaNp3sOCtqe/QBypIeG/iQI9ttcGpb/py8jeilh7++LheUNKeOFDry50Fx+UFaj/gKlGonPwr4JZnXoBLl6+WHnStZc9DqZtRy4tOOP/bQGlBoxElfDrdVr6xuhU21+wtaDc80aIjtLJxtSCRYEk/R+Mxy9ZHRQl7Cg+Zu4KE8cxNa80jm6xLBYm8JMrkJ1EmNwuNSqpEJkUZf14uNSxOvOn/AE1Lp4J5SBnmAAAAAElFTkSuQmCC"
                                alt="external-course-basic-ui-elements-2.3-sbts2018-outline-color-sbts2018"
                              />
                            </span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h5
                            className="mb-2 fs-15 fw-semibold"
                            style={{ height: "40px" }}
                          >
                            <span className="text-body">{course.title}</span>
                          </h5>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                course.description?.replace(/<[^>]*>/g, "") ||
                                "Description is not available",
                            }}
                            className="text-primary text-truncate-two-lines mb-2"
                            style={{ height: "40px" }}
                          />
                          <p className="text-primary mb-0">
                            <i className="ri-time-line me-1"></i>
                            Total Hours: {course.over_all_duration}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation Arrows - Only show when needed */}
        {showNavigation && (
          <>
            <div
              className="swiper-button-prev-custom"
              style={{
                position: "absolute",
                top: "40%",
                left: "-20px",
                transform: "translateY(-50%)",
                zIndex: 10,
                width: "40px",
                height: "40px",
                backgroundColor: "#fff",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                cursor: "pointer",
                transition: "all 0.3s ease",
                border: "1px solid #e9ecef",
              }}
            >
              <i
                className="ri-arrow-left-s-line"
                style={{ fontSize: "18px", color: "#6c757d" }}
              ></i>
            </div>

            <div
              className="swiper-button-next-custom"
              style={{
                position: "absolute",
                top: "40%",
                right: "-20px",
                transform: "translateY(-50%)",
                zIndex: 10,
                width: "40px",
                height: "40px",
                backgroundColor: "#fff",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                cursor: "pointer",
                transition: "all 0.3s ease",
                border: "1px solid #e9ecef",
              }}
            >
              <i
                className="ri-arrow-right-s-line"
                style={{ fontSize: "18px", color: "#6c757d" }}
              ></i>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default InstituteEnrollCourseCard;
